import { AmbassadorMedalIcon } from 'app/design/icons/ambassador-medal-icon';
import { Row, Column } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';

import { AmbassadorBottomSheet } from 'app/screens/profile/ambassador/ambassador-bottom-sheet';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Pressable, StyleSheet } from 'react-native';
import { useUISize } from 'app/utils/web-helpers';
import { useAmbassador } from 'app/hooks/use-ambassador';
import { createTheme as createDSTheme } from 'app/shopify';
import { IconChevronRight } from '@tabler/icons-react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
const theme = createDSTheme();

const styles = StyleSheet.create({
  pressableLargeUI: { flex: 1 },
  rowLargeUI: { flex: 1 },
  avatarContainer: {
    width: 44,
    height: 44,
    borderRadius: 22,
    backgroundColor: theme.colors['surface.secondary'],
  },
});

export function AmbassadorUsersBanner() {
  const { t } = useTranslation('ambassador');
  const [sheetOpen, setSheetOpen] = useState(false);
  const { isLargeUI } = useUISize();
  const { canBecomeAmbassador } = useAmbassador();
  if (!canBecomeAmbassador) {
    return null;
  }
  return (
    <>
      <Pressable onPress={() => setSheetOpen(true)} style={isLargeUI ? styles.pressableLargeUI : null}>
        <Row
          alignItems="center"
          backgroundColor="surface.brand.default"
          borderRadius="radius.lg"
          gap="spacing.general.x4"
          padding="spacing.general.x4"
          style={isLargeUI ? styles.rowLargeUI : undefined}
        >
          <Row alignItems="center" justifyContent="center" style={styles.avatarContainer}>
            <AmbassadorMedalIcon width={28} height={28} color={theme.colors['surface.brand.default']} />
          </Row>
          <Column flex={1} gap="spacing.general.x1">
            <Text color="white" fontWeight="700" variant="bodyBase">
              {t('banner.title')}
            </Text>
            <Text color="white" variant="bodyBase">
              {t('banner.subtitle')}
            </Text>
          </Column>
          <IconChevronRight strokeWidth={ICON_STROKE_WIDTH} color={theme.colors.white} />
        </Row>
      </Pressable>
      <AmbassadorBottomSheet onClose={() => setSheetOpen(false)} open={sheetOpen} />
    </>
  );
}
